var map = {
	"./home_zjgx_pic1.png": "iPBx",
	"./home_zjgx_pic2.png": "KcUH",
	"./home_zjgx_pic3.png": "hhuf",
	"./home_zjgx_pic4.png": "27dw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "vb3C";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/home_zjgx_pic.*\.png$
// module id = vb3C
// module chunks = 0